import React from 'react';
import { TrophyIcon, CheckIcon } from './Icons';

/**
 * Renders inline code spans: text wrapped in backticks → <code> elements.
 */
function renderWithCode(text) {
  if (!text || !text.includes('`')) return text;
  return text.split(/(`[^`]+`)/).map((part, i) => {
    if (part.startsWith('`') && part.endsWith('`')) {
      return <code key={i} className="req-inline-code">{part.slice(1, -1)}</code>;
    }
    return part;
  });
}

export default function RequirementsCard({ exercise, testResults }) {
  const testCases = exercise?.test_cases || [];

  const passedCount = testCases.filter(tc => {
    const r = testResults[tc.id];
    return r?.passed;
  }).length;

  return (
    <div className="card requirements-card">

      {/* Header */}
      <div className="req-card-header">
        <span className="req-trophy-icon" aria-hidden="true">
          <TrophyIcon size={14} />
        </span>
        <span className="req-card-title">Requirements</span>
        <span className="req-count">
          <strong>{passedCount}</strong>
          <span className="req-count-sep"> of </span>
          <strong>{testCases.length}</strong>
          <span className="req-count-label"> passing</span>
        </span>
      </div>

      {/* Rows */}
      <div className="req-card-body">
        {testCases.length === 0 ? (
          <p className="req-empty">No requirements yet.</p>
        ) : (
          <ul className="req-rows">
            {testCases.map((tc) => {
              const r  = testResults[tc.id];
              const passed = r?.passed === true;
              const tested = !!r;

              return (
                <li
                  key={tc.id}
                  className={`req-row ${passed ? 'req-row-pass' : tested ? 'req-row-fail' : 'req-row-pending'}`}
                >
                  {/* Circle indicator */}
                  <span className="req-circle" aria-hidden="true">
                    {passed ? (
                      <span className="req-circle-filled">
                        <CheckIcon size={9} />
                      </span>
                    ) : (
                      <span className="req-circle-empty" />
                    )}
                  </span>

                  {/* Requirement text */}
                  <span className="req-row-text">
                    {renderWithCode(tc.description)}
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </div>

    </div>
  );
}
